import { Component, OnInit, Input } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { TiktokService } from "src/app/services/social/tiktok.service";

@Component({
  selector: "app-tiktok-item",
  templateUrl: "./tiktok-item.component.html",
  styleUrls: ["./tiktok-item.component.css"],
})
export class TiktokItemComponent implements OnInit {
  @Input() tiktok: any;
  @Input() itemType: "comment" | "mention" = "comment";

  replyText: string = "";
  isReplying: boolean = false;
  showReplyInput: boolean = false;
  showVideoModal: boolean = false;
  showCommentModal: boolean = false;
  isLoadingVideo: boolean = false;
  videoFeeds: Array<any> = [];
  embedUrl: SafeResourceUrl | null = null;
  constructor(
    private tiktokService: TiktokService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {}

  openReplyModal(item: any) {
    this.showReplyInput = !this.showReplyInput;
    this.replyText = "";
  }

  openVideo(videoId: string) {
    console.log("video id", videoId);
    this.isLoadingVideo = true;
    this.embedUrl = null;
    this.showVideoModal = true;
    const matchingVideo = this.videoFeeds.find(
      (feed) => feed.item_id === videoId
    );

    if (matchingVideo && matchingVideo.embed_url) {
      this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        matchingVideo.embed_url
      );
      this.isLoadingVideo = false;
    } else {
      this.tiktokService.fetchFeeds().subscribe(
        (response: any) => {
          if (response.success && response.data) {
            this.videoFeeds = response.data;
            const video = this.videoFeeds.find(
              (feed) => feed.item_id === videoId
            );
            if (video && video.embed_url) {
              this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                video.embed_url
              );
            }
          }
          this.isLoadingVideo = false;
        },
        (error) => {
          console.error("Error fetching video:", error);
          this.isLoadingVideo = false;
          this.toastr.error("Unable to load video");
        }
      );
    }
  }

  closeVideoModal() {
    this.showVideoModal = false;
    this.embedUrl = null;
  }

  openCommentModal() {
    this.showCommentModal = true;
  }

  closeCommentModal() {
    this.showCommentModal = false;
  }

  submitReply(item: any) {
    if (!this.replyText.trim()) {
      this.toastr.error("Reply text cannot be empty");
      return;
    }

    if (this.replyText.length > 150) {
      this.toastr.error("Reply must be 150 characters or less");
      return;
    }

    this.isReplying = true;

    const videoId = item.video_id || item.item_id;
    const commentId = item.comment_id;

    this.tiktokService
      .replyToComment(
        videoId,
        commentId,
        this.replyText,
        this.itemType === "mention"
      )
      .subscribe({
        next: (response) => {
          console.log("replied response", response);
          this.isReplying = false;
          this.showReplyInput = false;
          this.replyText = "";
          item.replied = true;
          this.tiktok.replied = true;
          response.replied = true;
          this.toastr.success("Reply sent successfully!");
        },
        error: (error) => {
          this.isReplying = false;
          this.toastr.error("Failed to send reply");
        },
      });
  }

  cancelReply() {
    this.showReplyInput = false;
    this.replyText = "";
  }

  formatDate(timestamp: number): string {
    if (!timestamp) return "";
    const ts = timestamp < 10000000000 ? timestamp * 1000 : timestamp;
    const date = new Date(ts);
    return date.toLocaleDateString("en-GB");
  }

  formatDateTime(timestamp: number): string {
    if (!timestamp) return "";
    const ts = timestamp < 10000000000 ? timestamp * 1000 : timestamp;
    const date = new Date(ts);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }
}
